import RoomDetail from "@/components/RoomDetail";

const DoubleRoom = () => {
  return <RoomDetail roomType="double" />;
};

export default DoubleRoom;